import React, { useEffect, useState } from "react";
import Navbar from "../../bars/Navbar";
import Sidebar from "../../bars/Sidebar";
import WithRouter from "../../common/WithRouter";
import {
  fetchAtendidas,
  fetchNoAtendidas,
  fetchEstadisticasRiesgo
} from "../../services/apiService";

import { Col, Container, Row, Alert } from "react-bootstrap";
import { FcAdvertising } from "react-icons/fc";
import { FcCheckmark } from "react-icons/fc";
import { FcCancel } from "react-icons/fc";

import { Bs1CircleFill, Bs2CircleFill, Bs3CircleFill } from "react-icons/bs";


import { FcHome } from "react-icons/fc";

import "../../modales.css";

export const HomeBoard = () => {
  document.title = "Inicio | SIDEC";

  // Estados para paginación
  const [totalElements, setTotalElements] = useState(0);
  // eslint-disable-next-line
  const [quejas, setQuejas] = useState([]);
  const [atendidas, setAtendidas] = useState(0);
  const [noAtendidas, setNoAtendidas] = useState(0);

  useEffect(() => {
    const loadQuejas = async () => {
      try {

        const atendidasCount = await fetchAtendidas();
        const noAtendidasCount = await fetchNoAtendidas();

        setAtendidas(atendidasCount?.data?.totalElements || 0);
        setNoAtendidas(noAtendidasCount?.data?.totalElements || 0);

        setTotalElements(
          (atendidasCount?.data?.totalElements || 0) +
          (noAtendidasCount?.data?.totalElements || 0)
        );

      } catch (error) {
        console.error("Error:", error);
        setQuejas([]);
        setTotalElements(0);
        setNoAtendidas(0);
        setAtendidas(0);
      }
    };

    loadQuejas();
  }, []);

  const [riesgoStats, setRiesgoStats] = useState({ Bajo: 0, Medio: 0, Alto: 0 });

  useEffect(() => {
    const cargarEstadisticas = async () => {
      try {
        const data = await fetchEstadisticasRiesgo();

        setRiesgoStats({
          Bajo: data.Bajo || 0,
          Medio: data.Medio || 0,
          Alto: data.Alto || 0,
        });
      } catch (error) {
        console.error("Error al cargar estadísticas de riesgo", error);
      }
    };

    cargarEstadisticas();
  }, []);


  return (
    <>
      <div className="flex">
        <Sidebar />
        <div className="content w-100 cont">
          <Navbar />
          <div>
            <Container>
              <h1>
                <FcHome /> Panel de Administración SIDEC
              </h1>
              <br />

              <Row>
                <Col>
                  <Alert className="gob-alert alert-size">
                    <Alert.Heading className="text-center">
                      <h2>
                        <FcAdvertising />
                        <br />

                      </h2>
                      <b className="text-white">Total de Denuncias</b>
                      <br />
                      <span className="records-info">
                        <strong>{totalElements}</strong>
                      </span>
                    </Alert.Heading>
                  </Alert>
                </Col>
                <Col>
                  <Alert className="gob-alert alert-size">
                    <Alert.Heading className="text-center">
                      <h2>
                        <FcCheckmark />
                        <br />
                      </h2>
                      <b className="text-white">Quejas Atendidas</b>
                      <br />
                      <strong>{atendidas}</strong>
                    </Alert.Heading>
                  </Alert>
                </Col>
                <Col>
                  <Alert className="gob-alert alert-size">
                    <Alert.Heading className="text-center">
                      <h2>
                        <FcCancel />
                        <br />
                      </h2>
                      <b className="text-white">Quejas Sin Atender</b>
                      <br />
                      <strong>{noAtendidas}</strong>
                    </Alert.Heading>
                  </Alert>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Alert className="verde-alert alert-size">
                    <Alert.Heading className="text-center">
                      <h2>
                        <Bs1CircleFill />
                        <br />
                      </h2>
                      <b className="text-white">Bajo Riesgo</b>
                      <br />
                      <span className="records-info">
                        <strong>{riesgoStats.Bajo}</strong>
                      </span>
                    </Alert.Heading>
                  </Alert>
                </Col>
                <Col>
                  <Alert className="amarillo-alert alert-size">
                    <Alert.Heading className="text-center">
                      <h2>
                        <Bs2CircleFill />
                        <br />
                      </h2>
                      <b className="text-white">Mediano Riesgo</b>
                      <br />
                      <strong>{riesgoStats.Medio}</strong>
                    </Alert.Heading>
                  </Alert>
                </Col>
                <Col>
                  <Alert className="rojo-alert alert-size">
                    <Alert.Heading className="text-center">
                      <h2>
                        <Bs3CircleFill />
                        <br />
                      </h2>
                      <b className="text-white">Alto Riesgo</b>
                      <br />
                      <strong>{riesgoStats.Alto}</strong>
                    </Alert.Heading>
                  </Alert>
                </Col>
              </Row>

              <br />
              <div className="text-center">
                <img
                  height={353}
                  width={700}
                  src="riesgos.png" alt="Niveles de Riesgo" />
              </div>
              <hr />

              <p>
                Secretaría de Protección Civil: <b>Mediano y Alto Riesgo Unidades</b>
                <br />

                Municipales de Protección Civil: <b>Bajo Riesgo</b>
                <br/>

                <a
                  href="https://sidec.veracruz.gob.mx/documentos/Manual.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Manual del Sistema
                </a>
              </p>

            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithRouter(HomeBoard);
